export default function MarginBox({ children, ...props }) {

  const className = props.className ? props.className : ''
  const wrapperClassName = props.wrapperClassName ? props.wrapperClassName : ''
  return (
    <div className={wrapperClassName}
    style={{
      maxWidth: '100%'
    }}>
      <div className={className} style={{
        // display: 'flex',
        // alignItems: 'center',
        // justifyContent: 'center',
        height: '100%',
        maxWidth: 1440,
        margin: 'auto'
      }}>
        {children}
      </div>
    </div>
  );
}